import React from 'react';
import type { ReactionType } from '../../types';
type FishId = 'hero-orange' | 'clownfish' | 'moorish-idol';
const info: Record<FishId,{name:string,duration:number}> = {
 'hero-orange':{name:'Hero Orange',duration:16},
 'clownfish':{name:'Clownfish',duration:18},
 'moorish-idol':{name:'Moorish Idol',duration:20},
};
const css = `
@keyframes tc-v2-swim {0%,100%{translate:8% 0}50%{translate:72% 0}}
@keyframes tc-v2-turn {0%,49.99%{transform:scaleX(-1)}50%,100%{transform:scaleX(1)}}
@keyframes tc-v2-bob {0%,100%{transform:translateY(0) rotate(-1deg)}50%{transform:translateY(-7px) rotate(1deg)}}
@keyframes tc-v2-react {0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}
.tc-v2-swim{position:absolute;inset:0;animation:tc-v2-swim var(--tc-v2-duration) ease-in-out infinite}
.tc-v2-face{height:100%;width:100%;animation:tc-v2-turn var(--tc-v2-duration) step-end infinite}
.tc-v2-bob{width:100%;height:100%;animation:tc-v2-bob 4.5s ease-in-out infinite}
.tc-v2-react .tc-v2-bob{animation:tc-v2-react 1.2s ease-in-out infinite}
.tc-v2-static .tc-v2-swim,.tc-v2-static .tc-v2-face,.tc-v2-static .tc-v2-bob{animation:none!important}
.tc-v2-static .tc-v2-swim{translate:20% 0}
@media(prefers-reduced-motion:reduce){.tc-v2-swim,.tc-v2-face,.tc-v2-bob{animation:none!important}}
`;
export function ReworkedFish({id,reaction,reducedMotion,speed=1,active=false,dimmed=false}:{
 id:FishId;reaction:ReactionType|null;reducedMotion:boolean;speed?:number;active?:boolean;dimmed?:boolean;
}) {
 const fish=info[id];
 const duration=`${(fish.duration/Math.max(.1,speed)).toFixed(2)}s`;
 return <div className={`tc-v2 ${reducedMotion?'tc-v2-static':''} ${reaction&&!reducedMotion?'tc-v2-react':''}`}
   role="img" aria-label={fish.name+' V2'} style={{position:'absolute',inset:0,opacity:dimmed?.35:1,filter:active?'drop-shadow(0 0 14px #7dece9)':undefined,pointerEvents:'none'}}>
  <style>{css}</style><div className="tc-v2-swim" style={{'--tc-v2-duration':duration} as React.CSSProperties}>
   <div style={{position:'absolute',top:'50%',left:0,width:'22%',aspectRatio:'1.35 / 1',transform:'translateY(-50%)'}}>
    <div className="tc-v2-face" style={{'--tc-v2-duration':duration} as React.CSSProperties}><div className="tc-v2-bob">
      <img alt="" draggable={false} src={`/art/fish/rework-v2/${id}/approved-master.png`} style={{width:'100%',height:'100%',objectFit:'contain',display:'block'}} />
    </div></div>
   </div>
  </div>
 </div>;
}
